import { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

export default function ArrowLeftIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="M20.813 12a.563.563 0 0 1-.563.563H5.108l5.789 5.79a.563.563 0 1 1-.795.795l-6.75-6.75a.563.563 0 0 1 0-.795l6.75-6.75a.563.563 0 0 1 .795.795l-5.789 5.79H20.25a.563.563 0 0 1 .563.563"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
